











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {BaseFretebas} from '@/model/resource/BaseFretebas'
import {BaseFretebasCollection} from '@/model/collection/BaseFretebasCollection'
import {ListBaseFretebasSchema} from '@/schema/resource/BaseFretebas/ListBaseFretebasSchema'
import {CsvBaseFretebasSchema} from '@/schema/resource/BaseFretebas/CsvBaseFretebasSchema'

@Component
export default class ListBaseFretebasView extends Mixins(MixinQueryRouter) {
  schema = new ListBaseFretebasSchema()
  collection = new BaseFretebasCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: BaseFretebas) {
    Helper.pushByName('editBaseFretebas', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new BaseFretebasCollection().clearFilters().addFilter(params)

    await csv.listCsvBaseFretebas()
    new CsvBaseFretebasSchema().downloadCsv(csv.all())
  }
}
